import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getQuoteDetails, QuoteDTO } from '@setvi/shared/services/react-query';
import { processQuoteFromAPI } from '../utils/quote-helpers';

/**
 * Fetch quote data by ID
 * Uses the shared quotes query from @setvi/shared
 * Processes the quote to ensure all products have GP calculated
 *
 * Performance: processQuoteFromAPI is memoized to only run when query.data changes
 */
export const useQuote = (quoteId: string) => {
  const query = useQuery<QuoteDTO>(getQuoteDetails(quoteId));

  // Memoize the processed data to prevent expensive recalculation on every render
  const processedData = useMemo(
    () => processQuoteFromAPI(query.data),
    [query.data]
  );

  return {
    ...query,
    data: processedData
  };
};
